import { NavbarWidgetElement } from './define-navbar-element';

export function registerNavbarWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-navbar-widget')) return;

  window.customElements.define('adipa-navbar-widget', NavbarWidgetElement);
}
